










































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import TextArea from '@shared/components/forms/inputs/textarea/textarea.vue';
import { QuickPosSessionCreationFieldConfig } from '@pos/config/quick-pos-session-creation-fields';

interface FormModel {
  posBox: number | null;
  beginningCash: number | null;
  observations: string | null;
}

type FormModelErrorsObject = Partial<
  Record<'posBoxId' | 'beginningCash' | 'observations', string[]>
>;

@Component({
  name: 'QuickPosSessionCreationModal',
  components: {
    'b-modal': BModal,
    'bc-entity-select': EntitySelect,
    'bc-input-group': InputGroup,
    'bc-textarea': TextArea,
  },
})
export default class QuickPosSessionCreationModal extends Vue {
  isLoading: boolean = false;
  isProcessing: boolean = false;
  showNotAllowedPosBoxesWarning: boolean = false;
  formModel: FormModel = {
    posBox: null,
    beginningCash: null,
    observations: null,
  };

  errorsObject: FormModelErrorsObject = {};

  modalKey: number = 0;

  onChangeErrorObject(field): void {
    delete this.errorsObject[field];
  }
  manageSaveErrors(errors: any): void {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }

  onModalHidden(): void {
    this.resetForm();
  }

  resetForm(): void {
    this.formModel = {
      posBox: null,
      beginningCash: null,
      observations: null,
    };
    this.errorsObject = {};
    this.isLoading = false;
    this.showNotAllowedPosBoxesWarning = false;
    this.modalKey++;
  }

  onLoadedPosBoxes(items): void {
    if (items.length) {
      this.formModel.posBox = items[0].id;
      this.showNotAllowedPosBoxesWarning = false;
    } else {
      this.showNotAllowedPosBoxesWarning = true;
    }
  }

  show(): void {
    (this.$refs.modal as InstanceType<typeof BModal>)?.show();
  }
  close(): void {
    (this.$refs.modal as InstanceType<typeof BModal>)?.hide();
  }
  async createQuickPosSession() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      const data = await this.$posService.createQuickPosSession(
        this.formModel.posBox,
        this.formModel.beginningCash,
        this.formModel.observations,
      );

      if (data) {
        this.$store.commit('pos/clearOpenPosSession');
        this.$store.commit('pos/clearCurrentTicket');
        this.$store.dispatch('pos/getOpenPosSession');
        this.$root.$emit('refresh-pos-session-list');
      } else {
        const errorMsg = data.reason
          ? (this.$t(`global.payment.error_message.${data.reason}`) as string)
          : 'Payment not allowed';
        this.$bpcMessage.showErrorMessage({ text: errorMsg });
        this.$emit('close-modal');
      }
    } catch (errors) {
      this.manageSaveErrors(errors);
    }

    this.isProcessing = false;
  }

  // COMPUTED
  get title(): string {
    return this.$t('global.pos-session-creation-modal.title').toString();
  }

  get showNotAllowedPosBoxesWarningText(): string {
    return this.$t('global.pos-session-creation-modal.not-allowed-pos-boxes.alert').toString();
  }

  get fieldsConfig() {
    return QuickPosSessionCreationFieldConfig;
  }
}
